<template>
  <v-card>
    <v-card-title>
      Stamp Reason
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-list
        flat
        subheader
      >
        <v-list-item-group
          v-model="itemGroup"
        >
          <v-list-item v-for="(item, index) in stampReasonArray" :key="index" @click="setStampReason(item.value)">
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox :input-value="active"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="saveStampReason()"
      >OK</v-btn>
      <v-btn
        text
        @click="hideDialog"
      >Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DataType, Popup, Tool } from '@/util/index'
import { OriginationApi, OriginationBusinessApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'stamp-verification-dialog',
  props: {
    loan: {
      type: Object,
      default: () => {}
    },
    sectionKey: {
      type: String,
      default: ''
    },
    stampActionType: {
      type: Number,
      default: null
    },
    display: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      itemGroup: null,
      stampReason: null,
      stampReasonArray: [],
      conflictText: ''
    }
  },
  computed: {
  },
  watch: {
    display (val) {
      if (val) {
        this.dynamicStampReason()
      }
    }
  },
  mounted () {
    this.dynamicStampReason()
  },
  methods: {
    hideDialog () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$emit('hideDialog')
    },
    convertCheckSectionKey (sectionKey) {
      let result = ''
      switch (sectionKey) {
        case DataType.LoanSectionKey.PERSONAL:
          result = DataType.LoanSectionKey.BANKING
          break
        case DataType.LoanSectionKey.BANKING:
          result = DataType.LoanSectionKey.PERSONAL
          break
        default:
          break
      }
      return result
    },
    hasConflict (firstData) {
      let result = false
      if (this.sectionKey === DataType.LoanSectionKey.PERSONAL && this.stampReason === DataType.StampReasonEnum.PERSONAL_REMOTE_CONSENT.value) {
        result = firstData.code === DataType.StampReasonEnum.BANKING_VERIFIED_BY_CALL.value
        this.conflictText = result ? DataType.StampReasonEnum.BANKING_VERIFIED_BY_DL.text : ''
      }
      return result
    },
    async saveStampReason () {
      const $this = this
      if (tool.isNotEmpty($this.loan.id) && $this.stampActionType === DataType.StampActionTypeEnum.POSITIVE_STAMP.value && ($this.sectionKey === DataType.LoanSectionKey.PERSONAL || $this.sectionKey === DataType.LoanSectionKey.BANKING)) {
        const checkData = {
          loanId: $this.loan.id,
          feature: 'STAMP',
          condition: {
            sectionKey: $this.convertCheckSectionKey($this.sectionKey)
          }
        }
        let hasConflict = false
        let firstData
        await OriginationApi.listSectionFeature(checkData, function (result) {
          if (tool.isNotEmpty(result)) {
            firstData = result[0]
            hasConflict = $this.hasConflict(firstData)
          }
        }, function (result) {
          popup.popupForWarning(result.message)
        })
        if (hasConflict) {
          popup.popupForWarning(`The latest ${$this.convertCheckSectionKey($this.sectionKey)} stamp is not stamped as ${$this.conflictText}`)
          return false
        }
      }

      const saveData = {
        loanId: $this.loan.id,
        feature: 'STAMP',
        featureData: {
          sectionKey: $this.sectionKey,
          type: $this.stampActionType,
          code: $this.stampReason
        }
      }
      if (tool.isEmpty(this.itemGroup)) {
        popup.popupForWarning('Please select a stamp reason')
      } else {
        OriginationApi.addSectionFeature(saveData, function () {
          $this.$emit('changeLightIconType', $this.stampActionType)
          $this.$eventBus.$emit('updateStamp', $this.sectionKey)
          popup.popupForSuccess('Success to add stamp reason')
          $this.hideDialog()
        }, function (result) {
          popup.popupForWarning(result.message)
        })
      }
    },
    setStampReason (stampReason) {
      this.stampReason = stampReason
    },
    async dynamicStampReason () {
      const $this = this
      const result = []

      if ($this.sectionKey === DataType.LoanSectionKey.PAYMENT_OPTION && $this.stampActionType === DataType.StampActionTypeEnum.POSITIVE_STAMP.value) {
        const countData = {
          loanId: $this.loan.id,
          type: $this.stampActionType,
          sectionKey: $this.sectionKey
        }
        await OriginationBusinessApi.countLoanStamp(countData, function (resultData) {
          if (resultData === 0) {
            result.push(DataType.StampReasonEnum.PAYMENT_OPTION_EXPLANATION_IS_COMPLETED)
            result.push(DataType.StampReasonEnum.PAYMENT_ONLINE_PROGRAM)
          } else {
            result.push(DataType.StampReasonEnum.PAYMENT_OPTION_ADDITIONAL_EXPLANATION)
            result.push(DataType.StampReasonEnum.PAYMENT_OPTION_EXPLANATION_IS_EXPIRED)
            result.push(DataType.StampReasonEnum.PAYMENT_ONLINE_PROGRAM)
          }
        }, function () {
          result.push(DataType.StampReasonEnum.PAYMENT_OPTION_EXPLANATION_IS_COMPLETED)
        })
      } else {
        for (const item in DataType.StampReasonEnum) {
          if (DataType.StampReasonEnum[item].type === this.stampActionType && DataType.StampReasonEnum[item].sectionKey === this.sectionKey) {
            result.push(DataType.StampReasonEnum[item])
          }
        }
      }

      this.stampReasonArray = result
    }
  }
}
</script>
